(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rp-bestsellers-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.rp-bs').forEach(section => {
    const pills = section.querySelectorAll('.rp-bs__pill');
    const cards = section.querySelectorAll('[data-rp-bs-card]');
    const countEl = section.querySelector('[data-rp-bs-count]');
    const drawer = section.querySelector('[data-rp-bs-drawer]');
    const drawerToggle = section.querySelector('[data-rp-bs-filter-toggle]');
    const filterClear = section.querySelector('[data-rp-bs-filter-clear]');
    const filterApply = section.querySelector('[data-rp-bs-filter-apply]');
    const shopAllEl = section.querySelector('[data-rp-bs-shop-all]');
    const shopAllLink = section.querySelector('[data-rp-bs-shop-all-link]');
    const emptyEl = section.querySelector('[data-rp-bs-empty]');

    let activeCategory = 'all';
    let activeFilters = { metal: [], shape: [], price: [], availability: [] };
    const defaultPill = section.querySelector('.rp-bs__pill.is-active:not([data-filter="all"])');
    if (defaultPill) activeCategory = defaultPill.dataset.filter;

    function applyFilters() {
      let visible = 0;
      cards.forEach(card => {
        const cat = card.dataset.cat;
        const metal = (card.dataset.metal || '').split(',').map(s => s.trim());
        const shape = card.dataset.shape;
        const price = card.dataset.priceBucket;
        const avail = card.dataset.availability;
        let show = activeCategory === 'all' || cat === activeCategory;
        if (show && activeFilters.metal.length) show = activeFilters.metal.some(m => metal.includes(m));
        if (show && activeFilters.shape.length) show = activeFilters.shape.includes(shape);
        if (show && activeFilters.price.length) show = activeFilters.price.includes(price);
        if (show && activeFilters.availability.length) show = activeFilters.availability.includes(avail);
        card.classList.toggle('is-hidden', !show);
        if (show) visible++;
      });
      if (countEl) countEl.textContent = visible + ' style' + (visible === 1 ? '' : 's');
      if (emptyEl) emptyEl.hidden = visible > 0;
      if (activeCategory === 'all') {
        shopAllEl.hidden = true;
      } else {
        const activePill = section.querySelector('.rp-bs__pill.is-active');
        const url = activePill && activePill.dataset.shopAllLink;
        const label = (activePill && activePill.dataset.shopAllLabel) || 'Shop All →';
        if (url) { shopAllLink.href = url; shopAllLink.textContent = label; shopAllEl.hidden = false; }
        else { shopAllEl.hidden = true; }
      }
    }

    pills.forEach(pill => {
      pill.addEventListener('click', () => {
        pills.forEach(p => p.classList.remove('is-active'));
        pill.classList.add('is-active');
        activeCategory = pill.dataset.filter;
        applyFilters();
      });
    });

    if (drawerToggle) {
      drawerToggle.addEventListener('click', () => {
        drawer.classList.toggle('is-open');
      });
    }

    section.querySelectorAll('.rp-bs__filter-option').forEach(opt => {
      opt.addEventListener('click', () => opt.classList.toggle('is-selected'));
    });

    if (filterClear) {
      filterClear.addEventListener('click', () => {
        section.querySelectorAll('.rp-bs__filter-option').forEach(o => o.classList.remove('is-selected'));
        activeFilters = { metal: [], shape: [], price: [], availability: [] };
        applyFilters();
      });
    }

    if (filterApply) {
      filterApply.addEventListener('click', () => {
        activeFilters = { metal: [], shape: [], price: [], availability: [] };
        section.querySelectorAll('.rp-bs__filter-option.is-selected').forEach(o => {
          const type = o.dataset.filterType;
          const value = o.dataset.filterValue;
          if (activeFilters[type]) activeFilters[type].push(value);
        });
        applyFilters();
        drawer.classList.remove('is-open');
      });
    }

    section.querySelectorAll('[data-rp-bs-quick-add]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const handle = btn.dataset.productHandle;
        if (handle) window.location.href = '/products/' + handle;
      });
    });

    // ============ SORT DROPDOWN ============
    const sortToggle = section.querySelector('[data-rp-bs-sort-toggle]');
    const sortMenu = section.querySelector('[data-rp-bs-sort-menu]');
    const sortOptions = section.querySelectorAll('[data-sort]');
    const grid = section.querySelector('[data-rp-bs-grid]');
    const lifestyleTiles = grid ? grid.querySelectorAll('.rp-bs__tile') : [];

    // Capture original DOM order on init so Manual sort can restore it
    if (grid) {
      Array.from(grid.children).forEach((el, i) => el.dataset.origIndex = i);
    }

    if (sortToggle && sortMenu) {
      sortToggle.addEventListener('click', (e) => {
        e.stopPropagation();
        sortMenu.hidden = !sortMenu.hidden;
      });
      document.addEventListener('click', (e) => {
        if (!sortMenu.hidden && !sortMenu.contains(e.target) && e.target !== sortToggle) {
          sortMenu.hidden = true;
        }
      });
    }

    sortOptions.forEach(opt => {
      opt.addEventListener('click', () => {
        sortOptions.forEach(o => o.classList.remove('is-active'));
        opt.classList.add('is-active');
        const sortValue = opt.dataset.sort;
        sortGrid(sortValue);
        if (sortMenu) sortMenu.hidden = true;
      });
    });

    function sortGrid(method) {
      if (!grid) return;
      const items = Array.from(grid.children);
      const cards = items.filter(el => el.matches('[data-rp-bs-card]'));
      const tiles = items.filter(el => el.classList.contains('rp-bs__tile'));

      // Hide lifestyle tiles during price sorts (they break the shopping flow)
      tiles.forEach(t => t.style.display = method === 'manual' ? '' : 'none');

      if (method === 'manual') {
        // Restore original order using data-origIndex
        items.sort((a, b) => parseInt(a.dataset.origIndex) - parseInt(b.dataset.origIndex));
        items.forEach(el => grid.appendChild(el));
      } else {
        cards.sort((a, b) => {
          const ap = parseFloat(a.dataset.price) || 0;
          const bp = parseFloat(b.dataset.price) || 0;
          return method === 'price-asc' ? ap - bp : bp - ap;
        });
        cards.forEach(card => grid.appendChild(card));
      }
    }

    applyFilters();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
